import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateCanvas } from 'utils';
import { ActionButtons, ButtonContainer, ActionButton, TopRightActions, EditButton } from './styles';
import { ResetCameraOutlined } from 'components/icons/ResetCameraOutlined';
import { ScreenshotOutlined } from 'components/icons/ScreenshotOutlined';
import { ShadowsEnabledOutlined } from 'components/icons/ShadowsEnabledOutlined';
import { ShadowsDisabledOutlined } from 'components/icons/ShadowsDisabledOutlined';
import { EditOutlined } from 'components/icons/EditOutlined';
import { withTheme } from 'styled-components';
import constants from 'constants';

const { CANVAS_UPDATE_TYPES, CANVAS_UPDATE_METHODS, RATIOS, FOVEA_MODEL_URL, THEME } = constants;

const ActionArea = withTheme(props => {
  const { theme, guidURL, guid } = props;

  const dispatch = useDispatch();
  const appStore = useSelector(state => state.app);
  const canvasStore = useSelector(state => state.canvas);
  const rpcStore = useSelector(state => state.rpc);
  const modelEditable = rpcStore.modelEditable;
  const serializedData = useMemo(() => canvasStore.serializedData, [ canvasStore ]);
  const viewportShadows = serializedData?.metadata.viewportShadows;
  const selectedRatio = serializedData?.metadata.selectedRatio;
  const selectedTheme = appStore.theme;
  const white = theme.colors[selectedTheme].white;
  const isDark = selectedTheme === THEME.DARK;
  // Muted slate glyph on a light disc; inverted to a light glyph on the dark disc.
  const editIconColor = isDark
    ? theme.colors[selectedTheme].onPrimary
    : theme.colors[selectedTheme].darkGrey;

  const updateArgs = type => ({
    dispatch,
    type,
    method: CANVAS_UPDATE_METHODS.UPDATE,
  });

  return (
    <>
      {guidURL && modelEditable && (
        <TopRightActions>
          <EditButton
            theme={theme}
            $selectedTheme={selectedTheme}
            onClick={() => {
              window.location.href = `${FOVEA_MODEL_URL}/${guid}`;
            }}
          >
            <EditOutlined width={22} color={editIconColor} />
          </EditButton>
        </TopRightActions>
      )}

      {guidURL && (
        <ActionButtons>
          <ButtonContainer>
            <ActionButton
              theme={theme}
              $selectedTheme={selectedTheme}
              onClick={() => {
                const type = CANVAS_UPDATE_TYPES.CAMERA;
                const inboundData = { resetCamera: true };
                updateCanvas(updateArgs(type), inboundData);
              }}
            >
              <ResetCameraOutlined width={24} color={white} />
            </ActionButton>

            <ActionButton
              theme={theme}
              $selectedTheme={selectedTheme}
              onClick={() => {
                const type = CANVAS_UPDATE_TYPES.CAMERA;
                const inboundData = {
                  takeScreenshot: true,
                  aspectRatio: selectedRatio.value || RATIOS.broadcast.value,
                };

                updateCanvas(updateArgs(type), inboundData);
              }}
            >
              <ScreenshotOutlined width={24} color={white} />
            </ActionButton>

            <ActionButton
              theme={theme}
              $selectedTheme={selectedTheme}
              onClick={() => {
                const type = CANVAS_UPDATE_TYPES.VIEWPORT;
                const inboundData = { shadows: !viewportShadows };
                updateCanvas(updateArgs(type), inboundData);
              }}
            >
              {viewportShadows
                ? <ShadowsDisabledOutlined width={24} color={white} />
                : <ShadowsEnabledOutlined width={24} color={white} />
              }
            </ActionButton>
          </ButtonContainer>
        </ActionButtons>
      )}
    </>
  );
});

export { ActionArea };